<template>
    <path d="M31.119 6.124L25.876.88C25.314.32 24.551 0 23.758 0H11C9.344.006 8 1.35 8 3.006V18H.5c-.276 0-.5.224-.5.5v1c0 .276.224.5.5.5H16v3.292c0 .686.399 1.284 1.043 1.56.933.404 1.68-.1 1.93-.336l4.483-4.258c.35-.333.545-.78.545-1.257 0-.478-.193-.925-.544-1.257l-4.486-4.26c-.517-.488-1.275-.618-1.927-.336-.645.276-1.043.873-1.043 1.56V18H10V3.006C10 2.456 10.45 2 11 2h11.003v6.504c0 .832.668 1.496 1.5 1.496H30v19c0 .55-.45 1-1 1H11c-.55 0-1-.45-1-1v-7H8v7c0 1.656 1.344 3 3 3h18c1.656 0 3-1.344 3-3V8.249c0-.793-.319-1.562-.881-2.124zM18 15.32L21.875 19 18 22.68v-7.36zm6.002-7.316V2.037c.175.044.331.131.462.262l5.243 5.243c.131.131.219.287.262.462h-5.967z"/>
</template>

<script>
export default {
    name: 'importCsvIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 32 32');
    }
};
</script>
